import { date1IsBeforeDate2, validateDateObject } from '@/core/validators';
import deepCopy from 'deepcopy';

export function orderInitialValidationState() {

	return {
		isInvalid: null,
		etd: null,
		eta: null,
		atd: null,
		ata: null
	};
}

export function validateOrder(order) {
	let errorsOrder = { };

	let orderIsInvalid = false;

	errorsOrder.etd = order.etd && validateDateObject( order.etd );
	errorsOrder.eta = order.eta && validateDateObject( order.eta );
	errorsOrder.atd = order.atd && validateDateObject( order.atd );
	errorsOrder.ata = order.ata && validateDateObject( order.ata );

	if (errorsOrder.etd || errorsOrder.eta || errorsOrder.atd || errorsOrder.ata)
		orderIsInvalid = true;

	if (order.etd && order.eta && !errorsOrder.etd && !errorsOrder.eta) {

		let isInvalid;

		if (
			order.etd.date && order.eta.date
			&& ( order.etd.date.slice(0, 8) === order.eta.date.slice(0, 8) )
			&& order.etd.hasTime && !order.eta.hasTime
		) {
			isInvalid = false;

		} else {
			isInvalid = date1IsBeforeDate2(order.etd, order.eta);
		}

		if (isInvalid)
			orderIsInvalid = true;

		errorsOrder.etd = isInvalid;
		errorsOrder.eta = isInvalid;
	}

	if (order.atd && order.ata && !errorsOrder.atd && !errorsOrder.ata) {
		let isInvalid;

		if (
			order.atd.date && order.ata.date
			&& ( order.atd.date.slice(0, 8) === order.ata.date.slice(0, 8) )
			&& order.atd.hasTime && !order.ata.hasTime
		) {
			isInvalid = false;

		} else {
			isInvalid = date1IsBeforeDate2(order.atd, order.ata);
		}

		if (isInvalid)
			orderIsInvalid = true;

		errorsOrder.atd = isInvalid;
		errorsOrder.ata = isInvalid;
	}

	errorsOrder.isInvalid = orderIsInvalid;

	return errorsOrder;
}
